import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { filter, map } from 'rxjs';
import { progressActions } from '@app/store/progress/actions/progress.actions';
import { quizProgressActions } from '../actions/quiz-progress.actions';

@Injectable({
    providedIn: 'root',
})
export class QuizProgress_ProgressBridge {
    private readonly actions = inject(Actions);

    onFinishedQuizGetProgress$ = createEffect(() => {
        return this.actions.pipe(
            ofType(quizProgressActions.saveAnswerSuccess),
            filter(({ payload }) => payload.finished && payload.passed),
            map(() => progressActions.getProgress()),
        );
    });

    refetchAffectedProgress$ = createEffect(() => {
        return this.actions.pipe(
            ofType(quizProgressActions.saveAnswerSuccess),
            filter(({ payload }) => payload.finished && payload.passed),
            map(({ payload: { courseIds, moduleIds, pathwayIds } }) => progressActions.resetCachedProgressEntries({ courseIds, moduleIds, pathwayIds })),
        );
    });
}
